import React from 'react';
import { 
    BuyIcon, 
    TagIcon, 
    EditIcon, 
    RentIcon, 
    ForwardIcon 
} from './Icons';


const ACCENTS = {
    buy: { 
        text: 'text-sky-300', 
        hoverText: 'group-hover:text-sky-300',
        activeBorder: 'border-sky-400', 
    },
    sell: { 
        text: 'text-amber-300', 
        hoverText: 'group-hover:text-amber-300',
        activeBorder: 'border-amber-400', 
    },
    edit: { 
        text: 'text-sky-300', 
        hoverText: 'group-hover:text-sky-300',
        activeBorder: 'border-sky-400', 
    },
    rent: { 
        text: 'text-purple-300', 
        hoverText: 'group-hover:text-purple-300',
        activeBorder: 'border-purple-400', 
    },
    forward: { 
        text: 'text-emerald-300', 
        hoverText: 'group-hover:text-emerald-300',
        activeBorder: 'border-emerald-400', 
    },
};

const FormTabs = ({ activeTab, onSwitchToBuy, onSwitchToRent, onSwitchToForward }) => {
    const tabs = [
        (onSwitchToBuy || activeTab === 'buy') && { id: 'buy', label: 'Buy', icon: BuyIcon, onClick: onSwitchToBuy },
        activeTab === 'sell' && { id: 'sell', label: 'List Domain For Sale', icon: TagIcon },
        activeTab === 'edit' && { id: 'edit', label: 'Edit', icon: EditIcon },
        (onSwitchToRent || activeTab === 'rent') && { id: 'rent', label: 'Rent', icon: RentIcon, onClick: onSwitchToRent },
        (onSwitchToForward || activeTab === 'forward') && { id: 'forward', label: 'Forward', icon: ForwardIcon, onClick: onSwitchToForward },
    ].filter(Boolean);

    if (tabs.length === 0) return null;

    return (
        <div
            role="tablist"
            className="flex items-end gap-1.5 sm:gap-2 pl-6 pr-4 sm:px-6 relative z-30 pointer-events-auto select-none -mb-[1px] overflow-x-auto no-scrollbar"
        >
            {tabs.map((tab) => {
                const isActive = activeTab === tab.id;
                const accent = ACCENTS[tab.id] || ACCENTS.buy;
                const IconComponent = tab.icon;
                return (
                    <button
                        key={tab.id}
                        type="button"
                        role="tab"
                        aria-selected={isActive}
                        onClick={(e) => {
                            e.preventDefault();
                            if (!isActive && tab.onClick) tab.onClick();
                        }}
                        className={`group relative flex items-center justify-center gap-2 px-3.5 sm:px-6 rounded-t-xl sm:rounded-t-2xl text-xs sm:text-sm font-bold tracking-wide transition-all duration-200 ease-out cursor-pointer shrink-0 ${
                            isActive
                                ? `h-11 sm:h-12 bg-neutral-950 text-white border-t-2 ${accent.activeBorder} border-x border-white/[0.22] border-b-transparent z-20 shadow-lg`
                                : `h-9 sm:h-10 hover:h-11 sm:hover:h-12 bg-neutral-900/90 hover:bg-neutral-850 text-neutral-400 hover:text-white border-t border-x border-b border-white/[0.12] hover:border-white/[0.25] z-10`
                        }`}
                    >
                        {/* Icon */}
                        <IconComponent className={`w-3.5 h-3.5 sm:w-4 sm:h-4 shrink-0 transition-transform duration-200 ${
                            isActive 
                                ? `${accent.text} scale-105` 
                                : `text-neutral-400 group-hover:scale-105 ${accent.hoverText}`
                        }`} />

                        {/* Label */}
                        <span>{tab.label}</span>
                    </button>
                );
            })}
        </div>
    );
};

export default FormTabs;
